<template>
  <h3>Watchlist:</h3>
  <div class="card-container">
    <div v-show="watchlistStore.isEmpty">
      <p>Watchlist is currently empty, add projects from the project details view</p>
    </div>
    <div class="card" v-for="(item, index) in watchedProjects" :key="index">
      <div>
        <b>{{ item.id }}</b
        ><br />
        <p>{{ item.name }}</p>
        <p>{{ item.customer.invoiceName }}</p>
      </div>
      <div class="form-btns">
        <button
          type="button"
          @click="router.push({ name: 'project_details', params: { projectId: item.id } })"
        >
          View
        </button>
        <button type="button" @click="watchlistStore.remove(item.id)">Un-watch</button>
      </div>
    </div>
  </div>
  <!--div class="debug">
     <p>watching : {{ watchlistStore.watching }}</p>
     <p>watchedProjects : {{ watchedProjects }}</p>
    </div>-->
</template>

<script setup lang="ts">
//import { ref, computed } from 'vue';
import router from '@/router'
//import { useProjectStore } from '@/stores/project';
import { useWatchlistStore, useProjectStore } from '@/stores'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
const watchlistStore = useWatchlistStore()
const projectStore = useProjectStore()
const { watching } = storeToRefs(watchlistStore)
const { allProjects } = storeToRefs(projectStore);
//const allProjects = await projectStore.getAll()

function cardClicked(projectId) {
  console.log('Watchlist.cardClicked()...')
  console.log('item = ' + projectId)

  router.push({
    name: 'project_details',
    params: {
      //  project: item
      projectId: projectId.toString()
      //view: 'details'
    }
  })
}

const watchedProjects = computed(() => {
  return allProjects.value.filter((proj) => {
    return watching.value.includes(proj.id)
  })
})
</script>

<style lang="css" scoped>
.card-container {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  /*overflow: scroll;*/
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 2px solid black;
  border-radius: 5px;
  width: 15rem;
  min-height: 16rem;
  /*height: 10rem;*/
  padding: 1rem;
}
</style>
